import { buildGraphqlQuery } from '@ztechapps/common.utils'

const documentFragment = `
    _id
    name
    value
    description
    isDefault
    filterTemplateId
    autoApplyFilterTemplate
    filter
    category
    scope {
      key
    }
    `

export const templateQueries = buildGraphqlQuery('Template', documentFragment)
